<template>
<div>
  <h2>
    Welcome {{user.data.displayName}}!
  </h2>
  <br />

  <div class="container m-2 d-flex justify-content-around flex-wrap">

    <router-link to="game" class="m-2">
      <div class="card bg-dark">
        <img class="card-img-top" src="@/assets/site/thumb-demo-movement.png">
        <div class="card-body">
          <h5 class="card-title">Movement Demo</h5>
          <p class="card-text">
            The first proof of concept of Regal Arbor in a new engine
          </p>
        </div>
      </div>
    </router-link>

    <router-link to="dashboard" class="m-2">
      <div class="card bg-dark">
        <img class="card-img-top" src="@/assets/site/folder.png">
        <div class="card-body">
          <h5 class="card-title">Chapter 1 Scene 1</h5>
          <p class="card-text">
            in progress
          </p>
        </div>
      </div>
    </router-link>

    <router-link to="dashboard" class="m-2">
      <div class="card bg-dark">
        <img class="card-img-top" src="@/assets/site/folder.png">
        <div class="card-body">
          <h5 class="card-title">Endless Axe Fight</h5>
          <p class="card-text">
            <strong>(in progress)</strong> Axe wielding mob combat test
          </p>
        </div>
      </div>
    </router-link>

  </div>
</div>
</template>

<style>

html {
  height: 100%;
}

body {
  width: 100%;
  min-height: 100%;
  background-color:rgb(0, 0, 0)!important;
  background: url(../assets/site/background-ra-7.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  color: white;
}

</style>

<style scoped>
h2 {
  text-align: center;
}

a {
  color: white!important;
  text-decoration: none!important;
}

.card {
  width: 18rem;
  min-height: 18rem;
  height: 100%;
  background-color: rgba(52,58,64,.75)!important;
}

.card-title {
  padding-bottom: .3em;
  text-decoration: underline;
}

.card-title:hover {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg id='squiggle-link' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:ev='http://www.w3.org/2001/xml-events' viewBox='0 0 20 4'%3E%3Cstyle type='text/css'%3E.squiggle{animation:shift .3s linear infinite;}@keyframes shift {from {transform:translateX(0);}to {transform:translateX(-20px);}}%3C/style%3E%3Cpath fill='none' stroke='%23ffffff' stroke-width='1' class='squiggle' d='M0,3.5 c 5,0,5,-3,10,-3 s 5,3,10,3 c 5,0,5,-3,10,-3 s 5,3,10,3'/%3E%3C/svg%3E");
  background-position: bottom;
  background-repeat: repeat-x;
  background-size: 10%;
  border-bottom: 0;
  padding-bottom: .3em;
  text-decoration: none;
}
</style>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>
